import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "banner w-full lg:h-18 h-60 relative" }
const _hoisted_3 = { class: "flex items-center flex-column w-full h-full" }
const _hoisted_4 = { class: "container mx-auto" }
const _hoisted_5 = { class: "flex flex-col items-center w-full container" }
const _hoisted_6 = { class: "w-full flex flex-row items-center justify-center -mt-6" }
const _hoisted_7 = { class: "flex flex-row items-center justify-between md:w-5/12 w-5/6" }
const _hoisted_8 = { class: "md:w-80 md:h-52 w-36 bg-white rounded-md flex flex-col items-center text-center md:px-6 px-2 card-shadow" }
const _hoisted_9 = { class: "mt-4 md:text-3xl text-xl text-pink-700" }
const _hoisted_10 = { class: "md:w-80 md:h-52 w-36 bg-white rounded-lg flex flex-col items-center text-center md:px-6 px-2 card-shadow" }
const _hoisted_11 = { class: "mt-4 md:text-3xl text-xl text-pink-700" }
const _hoisted_12 = { class: "title w-full flex flex-col items-center justify-center md:mt-20 mt-10" }
const _hoisted_13 = { class: "mt-8 text-4xl text-pink-700" }
const _hoisted_14 = { class: "w-full flex justify-center md:absolute md:bottom-6 md:my-0 mt-6 mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_divider_component = _resolveComponent("divider-component")!
  const _component_fa = _resolveComponent("fa")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_informational_text_component = _resolveComponent("informational-text-component")!

  return (_openBlock(), _createElementBlock("article", null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_divider_component, null, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createTextVNode("Contact")
                ])),
                _: 1,
                __: [0]
              })
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_fa, { icon: ['fas', 'phone'] })
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "md:mt-6 mt-4 text-black font-800 md:text-lg text-xs" }, " Bestelling plaatsen, reservatie boeken, dat kan! ", -1)),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "md:mt-6 mt-4 text-pink-800 md:text-md text-sm font-medium mb-2" }, " tel 03 298 88 13 ", -1))
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_fa, { icon: ['fas', 'envelope'] })
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "md:mt-6 mt-4 text-black font-800 md:text-lg text-xs" }, " Met vragen, informatie en andere dingen kan je ons mailen! ", -1)),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "md:mt-6 mt-4 text-pink-800 md:text-md text-sm font-medium mb-2" }, " Flavours@telenet.be ", -1))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_12, [
      _cache[5] || (_cache[5] = _createElementVNode("h1", { class: "text-gray-600 font-semibold md:text-2xl text-xl text-center" }, " En je vindt ons terug op volgend adres ", -1)),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_fa, { icon: ['fas', 'location-dot'] })
      ]),
      _cache[6] || (_cache[6] = _createElementVNode("h2", { class: "text-gray-600 font-semibold md:text-2xl text-xl text-center mt-4 underline" }, [
        _createElementVNode("a", {
          class: "flex flex-col",
          href: "https://www.google.com/maps/place/Flavours/@51.2201131,4.281056,17z/data=!3m1!4b1!4m5!3m4!1s0x47c3f4db941c30f3:0xd64929a07f439cef!8m2!3d51.2201131!4d4.28325",
          target: "_blank"
        }, [
          _createElementVNode("span", null, " Flavours Broodjeszaak"),
          _createElementVNode("span", null, "Grote Baan 193A"),
          _createElementVNode("span", null, "9120 Melsele")
        ])
      ], -1))
    ]),
    _createElementVNode("section", _hoisted_14, [
      _createVNode(_component_informational_text_component, null, {
        default: _withCtx(() => [
          _cache[8] || (_cache[8] = _createTextVNode(" Vragen i.v.m allergieën kan je in de zaak stellen of op onze ")),
          _createVNode(_component_router_link, { to: "/menu" }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createElementVNode("a", { class: "text-pink-700 font-semibold" }, "menu", -1)
            ])),
            _: 1,
            __: [7]
          }),
          _cache[9] || (_cache[9] = _createTextVNode(" bekijken "))
        ]),
        _: 1,
        __: [8,9]
      })
    ])
  ]))
}